import React, { useEffect, useState, useRef } from 'react';
import TableView from '../table/TableView';
import { useQuery, useLazyQuery, useSubscription } from '@apollo/client';
import { USER_RECENT_VIEWS_QUERY, USER_FAVOURITES_QUERY } from '../../graph/UserGraph';
import { RECENT_REPORTS_SUBSCRIPTION } from '../../graph/ReportGraph';
// import SimpleTableView from '../table/SimpleTableView';
// import { AnimatePresence, motion } from "framer-motion";
// import CircularProgress from '@mui/material/CircularProgress';
// import Skeleton from '@mui/material/Skeleton';


function UserReportHistory() {

    const [getLazyRecents, lazyRecents] = useLazyQuery(USER_RECENT_VIEWS_QUERY, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    const [getLazyFavourites, lazyFavourites] = useLazyQuery(USER_FAVOURITES_QUERY, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    const recentReportsMessage = useSubscription(RECENT_REPORTS_SUBSCRIPTION, {
        onData: (wsData) => {
            console.log(wsData, "this is recent reports message")
        }
    });

    useEffect(() => {
        getLazyRecents()
        getLazyFavourites()
    }, [])

    useEffect(() => {
        getLazyRecents()
    }, [recentReportsMessage.data])


    let data = {
        lazyRecents: lazyRecents,
        lazyFavourites: lazyFavourites
    }

    const tableData = data.lazyRecents.data?.me.recentViews
    // const pageInfo = data.lazySearchResults.data !== undefined ? data.lazySearchResults.data.executeSearch.pageInfo : null
    // const networkStatus = data.lazySearchResults.networkStatus
    // const fetchMore = data.lazySearchResults.fetchMore
    // const loading = data.lazySearchResults.loading

    return (
        <>

            <TableView
                key={"user-history-table-view"}
                data={tableData}
                tableSize={"small"}
                expandable={false}
                // pageInfo = {pageInfo}
                // networkStatus = {networkStatus}
                // fetchMore = {fetchMore}
                // loading = {loading}
                noDataMessage={"No recents history yet."}
                // noDataImage={"/static/images/no_favourites_yet.png"}
                stickyHeader={true}
                // keysToRemove={[]}
                relayPagination={false}
                // below inputs are required only if relay based  subscription is enabled 
                // cursor={cursor}
                // setCursor={setCursor}
                keysToKeep={['title', 'solution', 'region', 'segment', 'market', 'visitCount', 'lastVisit']}
                orderBy={'lastVisit'}
                order={"desc"}
                nestedField={"report"}
                // flattenDepth={1}
                otherFields={'visitTime'}
            />
            {/* </motion.div>
            </AnimatePresence> */}
        </>
    )
}
export default UserReportHistory;
